import { render } from "./SobreComponent.vue?vue&type=template&id=2ff2e9f4&scoped=true"
import script from "./SobreComponent.vue?vue&type=script&lang=js"
export * from "./SobreComponent.vue?vue&type=script&lang=js"

import "./SobreComponent.vue?vue&type=style&index=0&id=2ff2e9f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff2e9f4"]])

export default __exports__